import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ServiceTemplateScheduleRow } from "../serviceTemplateSchedulesViewConfig";
import { PERIOD_LABELS } from "../serviceTemplateSchedule.constants";

export const ServiceTemplateSchedulePeriodCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ServiceTemplateScheduleRow, string>) => {
        const label = PERIOD_LABELS[row.original.period] ?? row.original.period;

        return (
            <ViewTableCell>
                <span>{label}</span>
            </ViewTableCell>
        );
    },
);

ServiceTemplateSchedulePeriodCell.displayName =
    "ServiceTemplateSchedulePeriodCell";
